/* gr-product-card.js — Quick-add drawer for the gr-product-card snippet.
 * Used wherever the snippet renders (collection grid, homepage Featured
 * Collection, related products, etc.). Loaded globally from
 * layout/theme.liquid; collection-page-only behaviors (filter form +
 * AJAX filtering) live in gr-collection.js.
 *
 * Listens for clicks on [data-gr-quickadd] anywhere in the document,
 * fetches /products/{handle}.js, paints the variant picker, and posts
 * to /cart/add.js on submit.
 *
 * Split from gr-collection.js 2026-05-06.
 */
(function () {
  'use strict';

  var qa = document.getElementById('gr-quickadd');
  if (!qa) return;

  // Locale-aware base path: /fr/, /en-CA/, etc. on localized storefronts.
  // Without this, /products/handle.js returns the default-language data and
  // the FR storefront would see English option names ("Grind Type") and
  // option values ("Whole Bean") in the drawer.
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var i18n = {
    addToCart:     qa.dataset.i18nAddToCart     || 'Add to cart',
    soldOut:       qa.dataset.i18nSoldOut       || 'Sold out',
    selectOptions: qa.dataset.i18nSelectOptions || 'Select options',
    adding:        qa.dataset.i18nAdding        || 'Adding…',
    tryAgain:      qa.dataset.i18nTryAgain      || 'Try again',
  };
  var typeMap = {};
  try { typeMap = JSON.parse(qa.dataset.i18nTypeMap || '{}'); } catch (e) {}

  function localizeType(raw) {
    if (!raw) return '';
    var key = String(raw).toLowerCase().trim();
    return typeMap[key] || raw;
  }

  var qaEl = {
    eyebrow: qa.querySelector('[data-gr-qa-eyebrow]'),
    title: qa.querySelector('[data-gr-qa-title]'),
    img: qa.querySelector('[data-gr-qa-img]'),
    desc: qa.querySelector('[data-gr-qa-desc]'),
    price: qa.querySelector('[data-gr-qa-price]'),
    options: qa.querySelector('[data-gr-qa-options]'),
    body: qa.querySelector('[data-gr-qa-body]'),
    loading: qa.querySelector('[data-gr-qa-loading]'),
    submit: qa.querySelector('[data-gr-qa-submit]'),
    ctaLabel: qa.querySelector('[data-gr-qa-cta-label]'),
    link: qa.querySelector('[data-gr-qa-link]'),
  };

  var state = { product: null, selected: {}, variant: null };

  function openQA() {
    qa.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gr-cart-open');
  }
  function closeQA() {
    qa.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gr-cart-open');
  }
  qa.querySelectorAll('[data-gr-qa-close]').forEach(function (b) { b.addEventListener('click', closeQA); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qa.getAttribute('aria-hidden') === 'false') closeQA(); });

  // Delegate clicks on [data-gr-quickadd]
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gr-quickadd]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    loadProduct(btn.dataset.handle);
  });

  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }

  function loadProduct(handle) {
    openQA();
    qaEl.loading.hidden = false;
    fetch(ROOT + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        state.product = p;
        state.selected = {};
        // default to first available variant
        var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        if (first) {
          first.options.forEach(function (val, i) { state.selected[i] = val; });
        }
        paintQA();
        qaEl.loading.hidden = true;
      })
      .catch(function () { closeQA(); });
  }

  function paintQA() {
    var p = state.product;
    qaEl.eyebrow.textContent = localizeType(p.type) || 'Product';
    qaEl.title.textContent = p.title;
    var imgSrc = '';
    if (typeof p.featured_image === 'string') imgSrc = p.featured_image;
    else if (p.featured_image && p.featured_image.src) imgSrc = p.featured_image.src;
    else if (p.images && p.images.length) imgSrc = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
    qaEl.img.textContent = '';
    if (imgSrc) {
      var imgEl = document.createElement('img');
      imgEl.src = imgSrc;
      imgEl.alt = p.title;
      qaEl.img.appendChild(imgEl);
    }
    qaEl.desc.textContent = (p.description || '').replace(/<[^>]+>/g, '').slice(0, 120);
    qaEl.link.href = ROOT + 'products/' + p.handle;

    // Render option chips — clear existing children safely (no innerHTML).
    while (qaEl.options.firstChild) qaEl.options.removeChild(qaEl.options.firstChild);
    if (p.options && p.options.length === 1 && p.variants.length === 1) {
      // Single-variant product — skip option picker entirely
    } else {
      p.options.forEach(function (opt, i) {
        var optName = typeof opt === 'string' ? opt : (opt.name || opt);
        var wrap = document.createElement('div');
        wrap.className = 'gr-qa__opt';
        var lbl = document.createElement('span');
        lbl.className = 'gr-qa__opt-name';
        lbl.textContent = optName;
        wrap.appendChild(lbl);

        var values = document.createElement('div');
        values.className = 'gr-qa__opt-values';

        // Unique values for this position
        var seen = {};
        p.variants.forEach(function (v) {
          var val = v.options[i];
          if (seen[val]) return;
          seen[val] = true;
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'gr-qa__chip';
          chip.textContent = val;
          // available test: any variant matching selected-so-far with this value
          var trial = Object.assign({}, state.selected, {}); trial[i] = val;
          var match = variantFor(trial);
          if (match && !match.available) chip.classList.add('is-unavailable');
          if (state.selected[i] === val) chip.classList.add('is-active');
          chip.addEventListener('click', function () {
            state.selected[i] = val;
            paintQA();
          });
          values.appendChild(chip);
        });

        wrap.appendChild(values);
        qaEl.options.appendChild(wrap);
      });
    }

    // Resolve current variant
    state.variant = variantFor(state.selected);
    if (state.variant) {
      qaEl.price.textContent = money(state.variant.price);
      if (state.variant.available) {
        qaEl.submit.disabled = false;
        qaEl.ctaLabel.textContent = i18n.addToCart + ' — ' + money(state.variant.price);
      } else {
        qaEl.submit.disabled = true;
        qaEl.ctaLabel.textContent = i18n.soldOut;
      }
    } else {
      qaEl.submit.disabled = true;
      qaEl.ctaLabel.textContent = i18n.selectOptions;
    }
  }

  function variantFor(sel) {
    return state.product.variants.find(function (v) {
      return v.options.every(function (val, i) { return sel[i] === val; });
    }) || null;
  }

  qaEl.submit.addEventListener('click', function () {
    if (!state.variant || !state.variant.available) return;
    qaEl.submit.disabled = true;
    qaEl.ctaLabel.textContent = i18n.adding;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variant.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        closeQA();
        window.dispatchEvent(new CustomEvent('gr:cart:open'));
      })
      .catch(function () {
        qaEl.submit.disabled = false;
        qaEl.ctaLabel.textContent = i18n.tryAgain;
      });
  });
})();
